import { gql } from '@apollo/client/core';

export const ON_TICKET_MESSAGE_SENT = gql`
    subscription OnTicketMessageSent($ticket_id: ID!) {
        ticketMessageSent(ticket_id: $ticket_id) {
            id
            message
            created_at
            status
            scheduled_at
            sender {
                 ... on User { id name }
                 ... on Student { id surname first_name }
            }
            attachments {
                id
                file { url original_name mime_type }
            }
        }
    }
`;

export const ON_USER_NOTIFICATION = gql`
    subscription OnUserNotification($id: ID!, $type: String!) {
        userNotification(id: $id, type: $type) {
            id
            read_at
            title
            message
            created_at
            type
            metadata
        }
    }
`;
